import React, { useState } from "react";
import { Navbar, Nav, Button, Container, NavDropdown } from "react-bootstrap";
import smallLogo from "../assets/smallLogo.png";

const NavigationBar = () => {
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);

  return (
    <Navbar expand="lg" className="navbar-custom">
      <Container>
        <Navbar.Brand href="/">
          <img src={smallLogo} alt="Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto align-items-center">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/WhatWeDo">What We Do</Nav.Link>
            <Nav.Link href="/HowItWorks">How It Works</Nav.Link>
            <Nav.Link href="/NonMuslims">Non Muslims</Nav.Link>
            <Nav.Link href="/Eid-Al-Adha">Eid-Al-Adha</Nav.Link>

            <NavDropdown
              title="About Us"
              id="about-us-dropdown"
              show={showAboutDropdown}
              onMouseEnter={() => setShowAboutDropdown(true)}
              onMouseLeave={() => setShowAboutDropdown(false)}
              renderMenuOnMount
            >
              {/* <NavDropdown.Item href="/Testimonials">Testimonials</NavDropdown.Item> */}
              <NavDropdown.Item href="/FAQ">FAQ</NavDropdown.Item>
              <NavDropdown.Item href="/Contact">Contact Us</NavDropdown.Item>
              <NavDropdown.Item href="/Testimonials">Testimonials</NavDropdown.Item>
              <NavDropdown.Item href="/Musallah">Musallah</NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <Nav className="ms-auto d-flex align-items-center gap-2">
            <Button href="/ApplyForHelp" className="nav-button apply-button">
              Apply For Help
            </Button>

            <Button
              href="/PayZakatHere"
              className="nav-button zakat-button"
            >
              Pay Zakat Here
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
